import { Module } from "wrapper6";
import PostSlider from "../utils/_post-slider";

var $ = jQuery;

export default class PostSliders extends Module {

	ready(app) {

        /**
         * For articles
         */
        const ARTICLE_WRAPPERS = document.querySelectorAll('.mtt-articles');
        if (ARTICLE_WRAPPERS.length) {
            for (let i = 0; i < ARTICLE_WRAPPERS.length; i++) {
                new PostSlider(ARTICLE_WRAPPERS[i], 'filter_articles', 1200);
            }
        }

        /**
         * For projects
         */
        const PROJECT_WRAPPERS = document.querySelectorAll('.mtt-projects');
        if (PROJECT_WRAPPERS.length) {
            for (let i = 0; i < PROJECT_WRAPPERS.length; i++) {
                new PostSlider(PROJECT_WRAPPERS[i], 'filter_projects');
            }
        }

        /**
         * For results
         */
        const RESULT_WRAPPERS = document.querySelectorAll('.mtt-results');
        if (RESULT_WRAPPERS.length) {
            for (let i = 0; i < RESULT_WRAPPERS.length; i++) {
                new PostSlider(RESULT_WRAPPERS[i], 'filter_results');
            }
        }

        /**
         * For focus areas
         */
        const FOCUSAREAS_WRAPPERS = document.querySelectorAll('.mtt-focus-areas');
        if (FOCUSAREAS_WRAPPERS.length) {
            for (let i = 0; i < FOCUSAREAS_WRAPPERS.length; i++) {
                new PostSlider(FOCUSAREAS_WRAPPERS[i], '');
            }
        }

        /**
         * For labour reports
         */
        const LABOUR_WRAPPERS = document.querySelectorAll('.mtt-labour-reports');
        if (LABOUR_WRAPPERS.length) {
            for (let i = 0; i < LABOUR_WRAPPERS.length; i++) {
                new PostSlider(LABOUR_WRAPPERS[i], 'filter_labour');
            }
        }

        /**
         * For anual reports
         */
        const ANUAL_WRAPPERS = document.querySelectorAll('.mtt-anual-reports');
        if (ANUAL_WRAPPERS.length) {
            for (let i = 0; i < ANUAL_WRAPPERS.length; i++) {
                new PostSlider(ANUAL_WRAPPERS[i], 'filter_anual');
            }
        }

        /**
         * Init new sliders
         */
        const SEARCH_WRAPPERS = document.querySelectorAll('.mtt-search-slider');
        if (SEARCH_WRAPPERS.length) {
            for (let i = 0; i < SEARCH_WRAPPERS.length; i++) {
                new PostSlider(SEARCH_WRAPPERS[i], '');
            }
        }
    }
}